import { lighten, makeStyles } from '@material-ui/core';
import React from 'react';

const useStatusStyles = makeStyles(theme => ({
    vermelho: {
        fontWeight: 'bold',
        color: 'darkred'
    },

    verde: {
        fontWeight: 'bold',
        color: 'darkgreen'
    },

    cinza: {
        fontWeight: 'bold',
        color: 'gray'
    },

    azul: {
        fontWeight: 'bold',
        color: 'darkblue'
    },

    laranja: {
        fontWeight: 'bold',
        color: 'darkorange'
    },

    roxo: {
        fontWeight: 'bold',
        color: 'darkpurple'
    },

    dourado: {
        fontWeight: 'bold',
        color: 'gold'
    },

    vermelhoClaro: {
        fontWeight: 'bold',
        color: 'red'
    },

    verdeClaro: {
        fontWeight: 'bold',
        color: 'green'
    },

    marrom: {
        fontWeight: 'bold',
        color: 'brown'
    },

    fundoAzul: {
        fontWeight: 'bold',
        color: 'white',
        backgroundColor: 'darkblue'
    },

    fundoVermelho: {
        fontWeight: 'bold',
        color: 'white',
        backgroundColor: 'darkred'
    },

    fundoVerde: {
        fontWeight: 'bold',
        color: 'white',
        backgroundColor: 'darkgreen'
    },

    fundoLaranja: {
        fontWeight: 'bold',
        color: 'white',
        backgroundColor: 'darkorange'
    },

    fundoRoxo: {
        fontWeight: 'bold',
        color: 'white',
        backgroundColor: 'darkpurple'
    }
}), {
    index: 1
});

const useStateStyles = makeStyles(theme => ({
    backgroundDisabled: {
        backgroundColor: 'lightgrey'
    }
}));

const useComponentStyles = makeStyles(theme => ({
    pageTitle: {
        backgroundColor: lighten(theme.palette.primary.light, 0.75),
        paddingTop: theme.spacing(1),
        paddingRight: theme.spacing(3),
        paddingBottom: theme.spacing(1),
        paddingLeft: theme.spacing(3)
    },

    pageContent: {
        paddingTop: theme.spacing(3),
        paddingRight: theme.spacing(3),
        paddingBottom: theme.spacing(3),
        paddingLeft: theme.spacing(3)
    },

    gridFilterBar: {
        backgroundColor: lighten(theme.palette.primary.light, 0.75),
    },

    successPanel: {
        backgroundColor: lighten(theme.palette.success.light, 0.75)
    },

    warningPanel: {
        backgroundColor: lighten(theme.palette.warning.light, 0.75)
    },

    fieldsetTitle: {
        padding: `${theme.spacing(1)}px ${theme.spacing(2)}px`,
        backgroundColor: 'rgba(0, 0, 0, .075)'
    },

    commandPanel: {
        padding: theme.spacing(1),
        backgroundColor: 'rgba(0, 0, 0, .1)'
    }
}));

export function useThemeColor () {
    const clsStatus = useStatusStyles();
    const clsState = useStateStyles();
    const clsComponent = useComponentStyles();

    return React.useMemo(() => ({
        status: clsStatus,
        state: clsState,
        component: clsComponent
    }), [clsStatus, clsState, clsComponent]);
}